<template>
    <a-select v-model:value="value" :mode="mode">
      <a-select-option :value='i.projectNameOuter' v-for='i of cpeProjects' :key='i.projectNameOuter' >{{i.projectNameOuter}}</a-select-option>
    </a-select>
</template>
<script lang='ts' setup>
import { ref, defineProps, defineEmits, computed, onMounted, watch } from 'vue';
import request from '@/utils/request'


const cpeProjects = ref([])

const props = defineProps({
  modelValue: {
    type: [String, Array],
  },
  mode: {
    type: String,
    default: '',
  },
})

const emits = defineEmits(['update:modelValue', 'changeValues'])

const value: any = computed({
  set(val) {
    emits('update:modelValue', val)
  },
  get() {
    return props.modelValue
  },
})
onMounted(async () => {
  await getCpeProjects()
})

async function getCpeProjects () {
  try {
    const rsp = await request.get('/api/in/kol/cpe/admin/project',{pageSize: 1000})
    cpeProjects.value = rsp.data.list
  } catch(err) {
    console.log('err')
  }
}
</script>
<style lang='scss' scoped>

</style>